import React, {useState, useContext, useEffect, useMemo} from 'react';
import {Context} from '../../Helpers/Auth';
import {useHistory, useParams} from 'react-router-dom';
import i18n from '../../i18n';
import {useTranslation} from 'react-i18next';
import TableChartIcon from '@mui/icons-material/TableChart';
import Calendario from '../../components/Agendamentos/Calendario';
import Agenda from '../../components/Agendamentos/Agenda';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import DrawerFilter from '../../components/Agendamentos/DrawerFilter';
import NovoAgendamento from '../../components/Agendamentos/NovoAgendamento';
import {getEstabelecimentos, getRepresentantes, getCategoriasReunioes} from '../requests';

function Agendamentos({negocio}) {
    const {t} = useTranslation();
    const history = useHistory();

    const [categorias, setCategorias] = useState([]);
    const [representantes, setRepresentantes] = useState([]);

    // Apresenta form de reunião ou não
    const [showForm, setShowForm] = useState(false);

    // Separador que está visivel
    const [openTab, setOpenTab] = React.useState(1);

    // Agendamento que está selecionado
    const [agendaSelecionada, setAgendaSelecionada] = useState(null);

    // flag com indicação de se foram efetuados alterações na reunião
    const [onChangeForm, setOnChangeForm] = useState(false);

    // Indica se o form está em modo de edição ou não
    const [editarAgendamentos, setEditarAgendamentos] = useState(false);

    // flag para guardar a reunião
    const [guardar, setGuardar] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    ///////////  Filtros /////////////////

    const [filtroDtInicio, setFiltroDtInicio] = useState({startDate: null, endDate: null});
    const [filtroDtFim, setFiltroDtFim] = useState({startDate: null, endDate: null});
    const [categoriaFiltro, setCategoriaFiltro] = useState([]);
    const [filtroCliente, setFiltroCliente] = useState('');
    const [filtroCodigo, setFiltroCodigo] = useState('');
    const [filtroNegocio, setFiltroNegocio] = useState('');
    const [filtroEstab, setFiltroEstab] = useState(null);
    const [filtroDescricao, setfiltroDescricao] = useState('');

    // const [filtroColaborador, setfiltroColaborador] = useState("");
    const [representanteFiltro, setRepresentanteFiltro] = useState([]);
    const [estabelecimentos, setEstabelecimentos] = useState([]);

    /////////////////////////////////////

    const {path, setPath} = useContext(Context);

    useEffect(() => {
        getEstabelecimentos(lang).then(function (response) {
            setEstabelecimentos(response.data.estabelecimentos);
        });

        getRepresentantes(lang).then(res => {
            setRepresentantes(res.data.representantes);
        });

        getCategoriasReunioes(lang).then(res => {
            setCategorias(res.data.categorias);
        });
    }, []);

    const handleRowClick = dados => {
        setAgendaSelecionada(dados);
        setEditarAgendamentos(false);
        setShowForm(true);
    };

    useEffect(() => {
        // se venho de um lead
        if (history.location.state?.lead) {
            setShowForm(true);
            setEditarAgendamentos(true);
        }

        // se venho de um prospect
        if (history.location.state?.prospect) {
            console.log('entrou');
            setShowForm(true);
            setEditarAgendamentos(true);
        }

        // se venho de um negocio
        if (history.location.state?.negocio) {
            setShowForm(true);
            setEditarAgendamentos(true);
        }
    }, [history]);

    const idiomaAtual = localStorage.getItem('i18nextLng');
    let lang;
    if (idiomaAtual == 'pt') {
        lang = 'POR';
    } else if (idiomaAtual == 'fr') {
        lang = 'FRA';
    } else if (idiomaAtual == 'en') {
        lang = 'EN';
    }else if (idiomaAtual == 'es') {
        lang = 'ES'; 
    }

    useEffect(() => {
        if (agendaSelecionada != null && showForm) {
            setPath(t('editarAgendamento') + ' ' + agendaSelecionada.id + '-' + agendaSelecionada.cliente);
        } else if (showForm && agendaSelecionada == null) {
            setPath(t('novoAgendamento'));
        } else {
            setPath('');
        }
    }, [path, agendaSelecionada, showForm]);

    return (
        <>
            <div className="border-b mb-5 border-gray-200 dark:border-gray-600">
                <div
                    className="flex flex-wrap items-center justify-between -mb-px text-sm font-medium text-center text-gray-500 dark:text-gray-400"
                    role="tablist"
                    id="myTab"
                    data-tabs-toggle="#myTabContent">
                    <div className="flex space-x-2">
                        {!showForm && (
                            <div>
                                <button
                                    aria-controls="agenda"
                                    id="agenda-tab"
                                    type="button"
                                    data-toggle="tab"
                                    href="#link1"
                                    role="tablist"
                                    aria-current="page"
                                    className={
                                        'inline-flex items-center justify-center p-4 border-b-2 rounded-t-lg group' +
                                        (openTab === 1
                                            ? ' justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group'
                                            : ' border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300')
                                    }
                                    onClick={e => {
                                        e.preventDefault();
                                        setOpenTab(1);
                                    }}>
                                    <TableChartIcon className="mr-2" />
                                    {t('agenda')}
                                </button>
                                <button
                                    aria-controls="calendario"
                                    id="calendario-tab"
                                    data-toggle="tab"
                                    href="#link2"
                                    role="tablist"
                                    type="button"
                                    // className="inline-flex items-center justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group"
                                    className={
                                        'inline-flex items-center justify-center p-4 border-b-2 rounded-t-lg group' +
                                        (openTab === 2
                                            ? ' justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group'
                                            : ' border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300')
                                    }
                                    onClick={e => {
                                        e.preventDefault();
                                        setOpenTab(2);
                                    }}>
                                    <CalendarTodayIcon className="mr-2" />
                                    {t('calendario')}
                                </button>
                            </div>
                        )}
                    </div>

                    <DrawerFilter
                        representantes={representantes}
                        categorias={categorias}
                        estabelecimentos={estabelecimentos}
                        setOnChangeForm={setOnChangeForm}
                        onChangeForm={onChangeForm}
                        setEditarAgendamentos={setEditarAgendamentos}
                        editarAgendamentos={editarAgendamentos}
                        showForm={showForm}
                        guardar={guardar}
                        setGuardar={setGuardar}
                        setShowForm={setShowForm}
                        setAgendaSelecionada={setAgendaSelecionada}
                        agendaSelecionada={agendaSelecionada}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        //filtros
                        representanteFiltro={representanteFiltro}
                        setRepresentanteFiltro={setRepresentanteFiltro}
                        categoriaFiltro={categoriaFiltro}
                        setCategoriaFiltro={setCategoriaFiltro}
                        filtroDescricao={filtroDescricao}
                        setfiltroDescricao={setfiltroDescricao}
                        filtroDtInicio={filtroDtInicio}
                        setFiltroDtInicio={setFiltroDtInicio}
                        filtroDtFim={filtroDtFim}
                        setFiltroDtFim={setFiltroDtFim}
                        filtroCliente={filtroCliente}
                        setFiltroCliente={setFiltroCliente}
                        filtroCodigo={filtroCodigo}
                        setFiltroCodigo={setFiltroCodigo}
                        filtroNegocio={filtroNegocio}
                        setFiltroNegocio={setFiltroNegocio}
                        filtroEstab={filtroEstab}
                        setFiltroEstab={setFiltroEstab}
                        // /filtros
                    />
                </div>
            </div>
            <div id="myTabContent">
                {openTab === 1 && !showForm && (
                    <Agenda
                        representantes={representantes}
                        categorias={categorias}
                        estabelecimentos={estabelecimentos}
                        setEditarAgendamentos={setEditarAgendamentos}
                        onRowClick={handleRowClick}
                        setRepresentanteFiltro={setRepresentanteFiltro}
                        representanteFiltro={representanteFiltro}
                        categoriaFiltro={categoriaFiltro}
                        setCategoriaFiltro={setCategoriaFiltro}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        //filtros
                        filtroDescricao={filtroDescricao}
                        setfiltroDescricao={setfiltroDescricao}
                        filtroDtInicio={filtroDtInicio}
                        setFiltroDtInicio={setFiltroDtInicio}
                        filtroDtFim={filtroDtFim}
                        setFiltroDtFim={setFiltroDtFim}
                        filtroCliente={filtroCliente}
                        setFiltroCliente={setFiltroCliente}
                        filtroCodigo={filtroCodigo}
                        setFiltroCodigo={setFiltroCodigo}
                        filtroNegocio={filtroNegocio}
                        setFiltroNegocio={setFiltroNegocio}
                        filtroEstab={filtroEstab}
                        setFiltroEstab={setFiltroEstab}
                        // /filtros
                    />
                )}

                <div className={openTab === 2 && !showForm ? 'block' : 'hidden'} id="link2">
                    <Calendario
                    representantes={representantes}
                        mostraFiltro={false}
                        mostraTarefa={false}
                        nomeTarefa={t('tarefas')}
                        setRepresentanteFiltro={setRepresentanteFiltro}
                        representanteFiltro={representanteFiltro}
                        categoriaFiltro={categoriaFiltro}
                        setCategoriaFiltro={setCategoriaFiltro}
                        setEditarAgendamentos={setEditarAgendamentos}
                        onRowClick={handleRowClick}
                        filtroDescricao={filtroDescricao}
                    />
                </div>
                {showForm && (
                    <NovoAgendamento
                        onChangeForm={onChangeForm}
                        setShowForm={setShowForm}
                        editarAgendamentos={editarAgendamentos}
                        setEditarAgendamentos={setEditarAgendamentos}
                        setGuardar={setGuardar}
                        guardar={guardar}
                        setOnChangeForm={setOnChangeForm}
                        agendaSelecionada={agendaSelecionada}
                    />
                )}
            </div>
        </>
    );
}

export default Agendamentos;
